import api from 'Application/api/api';

const getDriverLicenseTasksProgress = (cancelToken = null) =>
    api.get('/measures/vehicles/driver-licenses/tasks-progress', {
        cancelToken,
    });

export default getDriverLicenseTasksProgress;
